function tabClick(e) {
	9 === e.keyCode && (document.body.classList.add('js-using-tab'), window.removeEventListener('keydown', tabClick))
}
function wrap(e, t) {
	e.parentNode.insertBefore(t, e), t.appendChild(e)
}
window.addEventListener('keydown', tabClick)
const tableWrapper = document.createElement('div')
;(tableWrapper.setAttribute.style = 'overflow:auto;-webkit-overflow-scrolling:touch'),
	document.querySelectorAll('.rte table').forEach((e) => {
		wrap(e, tableWrapper)
	})
const scrollEndSupported = 'undefined' == typeof window || 'onscrollend' in window
scrollEndSupported || import('scrollyfills')
//# sourceMappingURL=global.js.map

